import type { FaturaPainel, FiltrosPainel } from '../types.ts';
import { calcularJanelaPeriodo, mesRefNaJanela } from '../../../../src/lib/financeiro/periodo.ts';

// Cópia local e minúscula de `removeAccents` (existe em FinanceiroLayout.tsx:184).
// NÃO importar de lá: este arquivo roda sob `node --test` via type-stripping
// nativo, que não processa JSX — importar de um .tsx quebraria o teste porque
// o Node precisa parsear o módulo inteiro (FinanceiroLayout.tsx tem milhares
// de linhas de JSX), não só o export usado.
function removeAccents(str: string | null | undefined): string {
  if (!str) return '';
  return String(str)
    .normalize('NFD')
    .replace(/\p{Mn}/gu, '') // remove marcas diacriticas (equivalente ao range usado em FinanceiroLayout.tsx:184, sem risco de escape)
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

// Aplica os 4 filtros globais da spec (seção 5) sobre o conjunto já com
// status derivado. Todos combinam com AND. Fonte de verdade dos filtros:
// docs/PLAN-painel-financeiro-executivo.md, seção 5.
export function filtrarFaturas(dados: FaturaPainel[], filtros: FiltrosPainel, hoje: Date): FaturaPainel[] {
  const janela = calcularJanelaPeriodo(filtros.periodo, hoje);
  const buscaNormalizada = removeAccents(filtros.clienteBusca);

  return dados.filter((f) => {
    if (!mesRefNaJanela(f.mes_referencia, janela)) return false;

    if (filtros.unidadeGeradora === 'outras') {
      if (f.unidade_geradora_1) return false;
    } else if (filtros.unidadeGeradora !== 'todas') {
      if (f.unidade_geradora_1 !== filtros.unidadeGeradora) return false;
    }

    if (filtros.status !== 'todos' && f.statusDerivado !== filtros.status) return false;

    if (buscaNormalizada) {
      const nomeNormalizado = removeAccents(f.cliente_nome);
      if (!nomeNormalizado.includes(buscaNormalizada)) return false;
    }

    return true;
  });
}
